import { Box, HStack, Link, Text } from '@chakra-ui/react';

import LanguageSwitcher from '../languageSwitcher/languageSwitcher';
import MainContentContainer from '../containers/main-content-container';
import React from 'react';
import SocialIcons from '../socials/social-icons';

function Banner() {
  return (
    <Box bg="rawSienna.500">
      <MainContentContainer>
        <HStack
          w="100%"
          h="44px"
          bg="rawSienna.500"
          alignItems="center"
          justifyContent="space-between"
          gap="8px"
        >
          <HStack alignItems="center" color="white">
            <Link href="https://afirmacijakulture.org/" color="white" _hover={{ color: "#fff", textDecor: 'underline' }}>Powered by ASK</Link>
          </HStack>
          <HStack gap="20px" alignItems="center">
            <Box display={{ base: 'none', lg: 'flex' }}>
              <LanguageSwitcher />
            </Box>
            <SocialIcons paddingTop='0px' bgColor='#fff' hoverColor='#FFEAE6' size='16px' bgSize='32px' iconColor='#BC2A2A' />

          </HStack>

        </HStack>
      </MainContentContainer >
    </Box>
  );
}

export default Banner;
